export default function navigation() {

  $('[data-hero-recto]').click (function(){
    $('.hero-recto').addClass('hide');
    $('.hero-verso').addClass('show');
  });
  
  $('[data-hero-verso]').click (function(){
    $('.hero-recto').removeClass('hide');
    $('.hero-verso').removeClass('show');
  });

}


// WEBPACK FOOTER //
// ./scripts/modules/hero.js